"use client";

import React from "react";
import { Quote } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Viktorija Kananaviciute",
  quote: "We would like to thank the doctor, neurosurgeon B. Spakauskas, on behalf of my father and myself. I would like to say a big THANK YOU to the clinic staff who took care of my father after the operation! My father was very satisfied with both the doctor's professionalism and human care, not every doctor cares and looks after his patients as sincerely as doctor B. Spakauskas. My father had a spine operation. My highest recommendations to you! The care is of the highest level, the food is amazing. The cleanliness in the clinic is meticulous. Which, I think, is really very important after the operation. The staff went to the ward many times to ask if it hurts or what is missing. The clinic is quiet, there is no noise. This clinic deserves to be written about, only good reviews!",
  position: "Neurosurgery Patient"
}, {
  author: "Gabriele Toliusyte",
  quote: "The greatest respect and gratitude to Dr. Stukas. A very competent neurosurgeon who knows his job. Also the clinic itself and its employees are very nice.",
  position: "Neurosurgery Patient"
}];
function TestimonialItem({
  testimonial,
  index
}: {
  testimonial: typeof testimonials[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <div ref={ref} data-index={index} className={`flex flex-col items-center text-center max-w-3xl mx-auto transition-all duration-1000 ease-out bg-card p-6 md:p-12 rounded-lg shadow-sm border border-border ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
      <Quote className="size-10 md:size-16 text-accent-foreground/30 mb-5 md:mb-8 rotate-180" aria-hidden="true" />
      <blockquote className="mb-6 md:mb-10">
        <p className="text-base md:text-xl font-default leading-relaxed text-foreground/90 italic">
          "{testimonial.quote}"
        </p>
      </blockquote>
      <div className="flex flex-col items-center gap-2">
        <cite className="text-base md:text-lg font-default font-bold not-italic text-primary">{testimonial.author}</cite>
        <span className="text-xs md:text-sm text-secondary-foreground font-default uppercase tracking-widest font-medium">{testimonial.position}</span>
        <span className="text-xs text-muted-foreground font-default mt-1">★★★★★ Verified Google Review</span>
      </div>
    </div>;
}
export default function VoicesOfRecovery() {
  return <section id="irish-patient-success-stories" className="bg-background text-foreground relative overflow-hidden py-12 md:py-20">
      <div className="container mx-auto relative z-10 px-4 sm:px-6">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-sm font-default font-bold tracking-widest uppercase text-primary mb-3">Patient Success Stories</h2>
          <div className="h-1 w-12 bg-accent-foreground/40 mx-auto rounded-full" />
        </div>
                <div className="max-w-3xl mx-auto mb-10 md:mb-16">
          <div className="relative aspect-video w-full overflow-hidden rounded-lg shadow-md border border-border bg-black">
            <iframe className="absolute inset-0 h-full w-full" src="https://www.youtube.com/embed/Dvns6VyYLpY" title="Patient story, Clinic Agatas" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen />
          </div>
          <p className="text-center text-sm md:text-base text-muted-foreground font-default mt-4 italic">
            Liudmila from Cork, Ireland, shares her experience of pain treatment at Clinic Agatas.
          </p>
        </div>
        <div className="flex flex-col gap-8 md:gap-16">
          {testimonials.map((testimonial, i) => <TestimonialItem key={i} index={i} testimonial={testimonial} />)}
        </div>
        <div className="text-center mt-10 md:mt-16">
          <a href="https://www.google.com/maps/place/Clinic+Agatas/@54.9128656,23.8862901,17z/data=!4m8!3m7!1s0x46e722bdd2de44d7:0xac022da03e371c88!8m2!3d54.9128656!4d23.888865!9m1!1b1!16s%2Fg%2F11flzgvmtp?hl=en&entry=ttu&g_ep=EgoyMDI2MDgyNC4wIKXMDSoASAFQAw%3D%3D" className="inline-flex items-center gap-2 px-8 py-4 rounded-lg border-2 border-[#264256] text-[#264256] text-base md:text-lg font-default font-bold hover:bg-[#264256] hover:text-white transition-all duration-300" target="_blank" rel="noopener noreferrer">
            Read our reviews on Google
          </a>
        </div>
      </div>
    </section>;
}